module.exports = __webpack_public_path__ + "assets/img/image01.462dc49c.jpg";